export const en = {
  "toastMessages.successLogin": "Login successful",
  "toastMessages.failedLogin": "Login failed",

  //Api Call
  "toastMessages.failedApiCall": "API call failed with status",

  //Master Call
  "toastMessages.failedLLMModelsMasterCall": "Failed to fetch LLM models",
  "toastMessages.failedEmbeddingModelsMasterCall": "Failed to fetch Embedding models",

  // Load Templates
  "toastMessages.failedLoadTemplates": "Failed to load templates",
  "toastMessages.noTemplates": "No templates found",

  // Create Template
  "toastMessages.failedCreateTemplate": "Failed to create template",
  "toastMessages.failedCreateTemplateWithStatus":
    "Failed to create template: {status}",
  "toastMessages.failedFetchTemplate": "Failed to fetch templates",
  "toastMessages.failedFetchAgent": "Failed to fetch agents",
  "toastMessages.templatesLoadedSuccess": "Templates loaded successfully",
  "toastMessages.templateCreatedSuccess": "Template created successfully",

  // Update Template
  "toastMessages.failedUpdateTemplate": "Failed to update template",
  "toastMessages.failedUpdateTemplateWithStatus":
    "Failed to update template: {status}",
  "toastMessages.templateUpdatedSuccess": "Template updated successfully",

  // Delete Template
  "toastMessages.failedDeleteTemplate": "Failed to delete template",
  "toastMessages.failedDeleteTemplateWithStatus":
    "Failed to delete template: {status}",
  "toastMessages.templateDeletedSuccess": "Template deleted successfully",

  // Load Agents
  "toastMessages.failedLoadAgents": "Failed to load agents",
  "toastMessages.failedLoadAgentsWithStatus": "Failed to load agents: {status}",

  // Delete Knowledge Base
  "toastMessages.failedDeleteKnowledge": "Failed to delete knowledge base",
  "toastMessages.knowledgeDeletedSuccess":
    "Knowledge base deleted successfully",

  // Knowledge Base
  "toastMessages.failedLoadKnowledgeUnexpectedFormat":
    "Failed to load knowledge bases: Unexpected data format.",
  "toastMessages.failedLoadKnowledgeUnexpectedError":
    "Failed to load knowledge bases: Unexpected error.",
  "toastMessages.failedAddKnowledge": "Failed to add knowledge base",
  "toastMessages.failedUpdateKnowledge": "Failed to update knowledge base",
  "toastMessages.failedFetchKnowledge": "Failed to fetch knowledge bases",
  "toastMessages.failedFetchKnowledgeByRole":
    "Failed to fetch knowledge bases by role",
  "toastMessages.knowledgeAddedSuccess": "Knowledge base added successfully!",
  "toastMessages.knowledgeUpdateSuccess":
    "Knowledge base updated successfully!",
  "toastMessages.knowledgeProcessing":
    "Knowledge base is currently being processed.",
  "toastMessages.knowledgeNotSelected": "No Knowledge selected",
  "toastMessages.knowledgeLoadedSuccess": "Knowledge bases loaded successfully",
  "toastMessages.knowledgeCreatedSuccess": "Knowledge created successfully",
  "toastMessages.knowledgeCreatedSuccessDescription":
    "The knowledge item has been added successfully.",
  "toastMessages.knowledgeUpdatedSuccess": "Knowledge updated successfully",
  "toastMessages.knowledgeUpdatedSuccessDescription":
    "The knowledge item has been updated successfully.",
  "toastMessages.failedCreateKnowledge": "Failed to create knowledge",
  "toastMessages.failedCreateKnowledgeDescription":
    "An error occurred while creating the knowledge item. Please try again.",
  "toastMessages.failedUpdateKnowledgeDescription":
    "An error occurred while updating the knowledge item. Please try again.",

  // Agent
  "toastMessages.failedAddAgent": "Failed to add Agent",
  "toastMessages.failedDeleteAgent": "Failed to delete Agent",
  "toastMessages.failedUpdateAgent": "Failed to update Agent",
  "toastMessages.failedFetchAgents": "Failed to fetch Agents",
  "toastMessages.failedFetchAgentDetails": "Failed to fetch Agent Details",
  "toastMessages.failedFetchGroups": "Failed to fetch Groups",
  "toastMessages.failedFetchOrganizations": "Failed to fetch Organizations",
  "toastMessages.agentAddedSuccess": "Agent added successfully!",
  "toastMessages.agentUpdatedSuccess": "Agent updated successfully!",
  "toastMessages.agentDeletedSuccess": "Agent deleted successfully!",
  "toastMessages.agentsLoadedSuccess": "Agents loaded successfully",

  // Query Library
  "toastMessages.failedLoadQueries": "Failed to load queries",
  "toastMessages.unableToFetchQueries": "Unable to fetch queries",
  "toastMessages.queriesLoadedSuccess": "Queries loaded successfully",
  "toastMessages.failedCreateQuery": "Failed to create query",
  "toastMessages.fillAllRequiredFieldsDescription":
    "Please fill all required fields",
  "toastMessages.queryCreatedSuccess": "Query created successfully",
  "toastMessages.failedUpdateQuery": "Failed to update query",
  "toastMessages.queryUpdatedSuccess": "Query updated successfully",
  "toastMessages.failedDeleteQuery": "Failed to delete query",
  "toastMessages.queryDeletedSuccess": "Query deleted successfully",
  //ConversationHistory
  "toastMessages.failedtoFetchConversationHistory":
    "Failed to Fetch Conversation History",
  "toastMessages.failedtoFetchConversationHistoryById":
    "Failed to Fetch Conversation History",
  "toastMessages.failedtoDeleteConversationHistory":
    "Failed to delete Conversation History ",
  "toastMessages.failedToSendMessage": "Failed to send message",
  //Agents
  "toastMessages.failedtoFetchAgentsList": "Failed to Fetch Agents",
  //KnowldegeBase
  "toastMessages.failedtoKnowledgeBaseList": "Failed to Fetch Knowledge Bases",
  //Prompt Template
  "toastMessages.failedToFetchPromptTemplates":
    "Failed to Fetch Prompt Templates",
  "toastMessages.": "Failed to load groups",
  //Chat
  "toastMessages.failedToFetchChatResponse": "Failed to fetch chat response",
  "toastMessages.failedtoAddFeedback": "Failed to Add Feedback",
  "toastMessages.failedToUpdateFeedback": "Failed to Update Feedback",
  // Performance
  "toastMessages.performanceDataLoadedSuccess": "Performance data loaded successfully",
  // RAI Metrics
  "toastMessages.raiMetricsLoadedSuccess": "RAI metrics loaded successfully",
  //Governance Metrics
  "toastMessages.governanceMetricsLoadedSuccess":
    "Governance metrics loaded successfully",
  "toastMessages.failedToFetchGovernanceMetrics":
    "Failed to load Governance Metrics",
  //User adoption Insight
  "toastMessages.analyticsDataRefreshed": "Analysis data refreshed",
  "toastMessages.userAdoptionInsightsLoadedSuccess":
    "User Adoption Insights loaded successfully",
  "toastMessages.failedUserAdoptionInsightsLoaded":
    "Failed to load User Adoption Insights",
  //Feedback Report
  "toastMessages.failedLoadFeedback": "Failed to load feedback data",
  "toastMessages.feedbackLoadedSuccess": "Feedback data loaded successfully",

  // Validation Messages
  "toastMessages.validationBasicSettings":
    "Please fill in all required fields in Basic Settings.",
  "toastMessages.validationSelectFile":
    "Please select at least one file for Document source type.",
  "toastMessages.validationWebUrl":
    "Please provide a Web URL for Web URL source type.",
  "toastMessages.validationError": "Validation Error",
  "toastMessages.summarizerError": "Summarizer error",
  "toastMessages.summarizerRequestFailed": "Summarizer request failed",
  "toastMessages.failedDelete": "Failed to delete",

  // Group Management
  "toastMessages.groupDeleted": "Group deleted",
  "toastMessages.groupUpdated": "Group updated",
  "toastMessages.groupCreated": "Group created",
  "toastMessages.subgroupCreated": "Subgroup created",

  // Auth Provider
  "toastMessages.sessionExpired": "Session expired",
  "toastMessages.sessionExpired.description": "Please login again",
  "toastMessages.failedStoredAuth": "Failed to parse stored auth",
  "toastMessages.invalidCredentails": "Invalid Credentials",
  "toastMessages.useAuthOutsideProvider":
    "useAuth must be used within an AuthProvider",

  "toastMessages.useThemeProvider":
    "useTheme must be used within a ThemeProvider",

  "toastMessages.fetchConversationError": "Error fetching conversation data.",

  "toastMessages.routeNotFound": "404 Error: Page Not Found",

  "toastMessages.notFoundCode": "404",
  "toastMessages.notFoundMessage": "Oops! Page not found",
  "toastMessages.returnHome": "Return to Home",

  "toastMessages.fixFormErrors": "Please fix form errors before saving",
  "toastMessages.multipleRolesCommaSeperated":
    "(comma-separated for multiple roles)",
  "toastMessages.multipleTasksCommaSeperated":
    "(comma-separated for multiple tasks)",

  "toastMessages.templateNotFound":
    "No templates found. Create your first template to get started!",
  "toastMessages.agentsNotFound":
    "No agents found. Create your first agent to get started!",
  "toastMessages.knowledgeNotFound":
    "No knowledge bases found. Create your first knowledge base to get started!",

  "toastMessages.noPermission":
    "You don't have permission to access this resource.",
  "toastMessages.accessDenied": "Access Denied",
  "toastMessages.returnDashboard": "Return to Dashboard",

  "toastMessages.settingsSaved": "Settings saved",
  "toastMessages.settingsUpdated": "Settings have been updated.",
  "toastMessages.deleteYourself": "Cannot delete yourself",
  "disclaimer.changesTitle": "Confirm agent changes",
  "disclaimer.changesDescription.systemAdmin":
    "Changing organizations affect visibility of agent. Updating knowledge bases can change agent responses. Do you want to continue?",
  "disclaimer.changesDescription.orgAdmin":
    "Changing groups affect visibility of agent. Updating knowledge bases can change agent responses. Do you want to continue?",
  "toastMessages.userDeleted": "User deleted successfully",
  "toastMessages.userUpdated": "User updated successfully",
  "toastMessages.userAdded": "User added successfully",
  "toastMessages.userCreated": "User created successfully",
  "toastMessages.userNotFound": "No Users Found",

  "toastMessages.newPassword": "New Password (leave blank to keep current)",

  "toastMessages.chatContent": "Hello! How can I help you today?",

  "toastMessages.deleteConfirmation": "Delete {{itemName}}",
  "toastMessages.logoutFailed": "Logout failed",
  "toastMessages.sessionExtendFailed": "Failed to extend session",
  "toastMessages.organizationListSuccess": "Organizations fetched successfully",
  "toastMessages.promptGuidanceSuccess": "Prompt guidance fetched successfully",
  "toastMessages.promptGuidanceFailure": "Failed to fetch Prompt guidance",
  "toastMessages.promptGuidanceDeleteSuccess":
    "Prompt guidance deleted successfully",
  "toastMessages.promptGuidanceDeleteFailure":
    "Failed to delete Prompt guidance",
  "toastMessages.promptGuidanceCreateSuccess":
    "Prompt guidance created successfully",
  "toastMessages.promptGuidanceCreateFailure":
    "Failed to create prompt guidance",
  "toastMessages.promptGuidanceUpdateSuccess":
    "Prompt guidance updated successfully",
  "toastMessages.promptGuidanceUpdateFailure":
    "Failed to update Prompt guidance",

  "toastMessages.groupListSuccess": "Groups fetched successfully",
  "toastMessages.groupListFailure": "Failed to fetch groups",
  "toastMessages.userListSuccess": "Users fetched successfully",
  "toastMessages.userListFailure": "Failed to fetch users",
  "toastMessages.userGroupSuccess": "User groups fetched successfully",
  "toastMessages.userGroupFailure": "Failed to fetch user groups",
  "toastMessages.organizationCreateSuccess":
    "Organization created successfully",
  "toastMessages.organizationCreateFailure": "Failed to create Organization",
  "toastMessages.groupCreateSuccess": "Group created successfully",
  "toastMessages.groupCreateFailure": "Failed to create Group",
  "toastMessages.groupUpdateSuccess": "Group updated successfully",
  "toastMessages.groupUpdateFailure": "Failed to update Group",
  "toastMessages.addUserSuccess": "User added successfully",
  "toastMessages.addUserFailure": "Failed to add user",
  "toastMessages.removeUserSuccess": "User removed successfully",
  "toastMessages.removeUserFailure": "Failed to remove user",
  "toastMessages.groupDeleteSuccess": "Group deleted successfully",
  "toastMessages.groupDeleteFailure": "Failed to delete Group",
  "toastMessages.organizationDeleteSuccess":
    "Organization deleted successfully",
  "toastMessages.organizationDeleteFailure": "Failed to delete Organization",
  "toastMessages.organizationListFailure": "Failed to fetch organizations list",
  "toastMessages.organizationUpdateSuccess":
    "Organization updated successfully",
  "toastMessages.organizationUpdateFailure": "Failed to update Organization",
  "toastMessageDescriptions.failedLoadKnowledgeUnexpectedFormat":
    "The server returned an unexpected response structure.",
  "toastMessageDescriptions.failedLoadKnowledgeUnexpectedError":
    "An unexpected error occurred while loading knowledge bases. Please try again.",
  "toastMessageDescriptions.summarizerError":
    "Summarization failed. Check your URL or file and try again.",
  "toastMessageDescriptions.summarizerRequestFailed":
    "An error occurred while requesting summarization. Please try again later.",
  "toastMessageDescriptions.unknownError":
    "Something went wrong. Please try again.",
  "toastMessageDescriptions.successLoginDescription": "Welcome back!",
  "toastMessageDescriptions.failedLoginDescription":
    "Please check your credentials and try again.",
  "toastMessageDescriptions.routeDescription": "Attempted to access: ",
  "toastMessageDescriptions.deleteDescription":
    "This action cannot be undone. This will permanently delete the selected {{descriptionTag}}.",
  "toastMessages.genericError": "Something went wrong. Please try again.",
  "toastMessages.noOrganizationFound":
    "No organization found. Please create an organization first.",
  "toastMessages.fetchOrganizationFailed": "Failed to fetch organizations",
  "toastMessages.failedLoadGroups": "Failed to fetch groups",
  "toastMessages.failedLoadVersions": "Failed to fetch versions",
  "toastMessages.failedLoadDetails": "Failed to fetch details",
  "toastMessages.noGroupFound": "No groups found",
  "toastMessages.createGroupFirst":
    "Please create a group before assigning a Group Admin",
  "toastMessages.fetchGroupFailed": "Failed to fetch groups",
  "toastMessages.userCreateFailed": "Failed to create user",
  "toastMessages.userUpdateFailed": "Failed to update user",
  "toastMessages.userDeleteFailed": "Failed to delete user",
  "toastMessages.fetchUserFailed": "Failed to fetch user",
  "toastMessages.notAllowed": "Action not allowed",
  "toastMessages.cannotEditOrgAdmin": "Edit not allowed",
  "toastMessages.invalidDateRange": "Invalid date range",
  "toastMessages.invalidDateRangeDescription":
    "Start date cannot be after end date.",

  "templateDescriptions.nameDescription":
    "Give your template a clear, descriptive name",
  "templateDescriptions.versionDescription":
    "Enter version number for this template.",
  "templateDescriptions.agentsDescription": "Select all the agents",
  "templateDescriptions.roleDescription": "Define the AI's role and expertise",
  "templateDescriptions.taskDescription": "What should the AI accomplish?",
  "templateDescriptions.requirementsDescriptions":
    "Specify any prerequisites or conditions",
  "templateDescriptions.detailsDescription": "Extra context and specifications",
  "templateDescriptions.restrictionDescription":
    "Define limitations and boundaries",
  "templateDescriptions.formatDescription":
    "Specify the desired output structure",
  "templateDescriptions.exampleDescription":
    "Provide examples to guide the AI's understanding",
  "templateDescriptions.temperatureDescription":
    "Set the model temperature (0-1)",
  "templateDescriptions.topPDescription":
    "Set top-p sampling probability (0-1)",
  "templateDescriptions.topKDescription": "Set top-k sampling probability",
  "templateDescriptions.maxInputTokensDescription":
    "Maximum tokens allowed for input",
  "templateDescriptions.maxOutputTokensDescription":
    "Maximum tokens allowed for output",
  "templateDescriptions.stopSequenceDescription": "Sequence to stop generation",
  "templateDescriptions.organizationSelect":
    "Select one or more organizations for the template",
  "templateDescriptions.groupSelect": "Choose the groups for the template",
  "placeholders.selectModel": "Select model",
  "placeholders.name": "Chatbot",
  "placeholders.version": "1",
  "placeholders.agents": "Select Agents",
  "placeholders.role": "Select role",
  "placeholders.task":
    "Please provide a clear, comprehensive overview of what AI can accomplish today and its potential future capabilities.",
  "placeholders.requirements":
    "Clearly provide requirements in bullet points. Limit your response to 300 words.",
  "placeholders.details":
    "Respond in English with a formal, respectful, and academically appropriate tone.",
  "placeholders.restrictions":
    "Avoid assumptions, rude or harmful content, and keep responses neutral and factual.",
  "placeholders.format":
    "Please present the output clearly in the form of a table, with appropriate headers and rows included.",
  "placeholders.examples":
    "Input: Hi John, can we reschedule our meeting to Friday instead of Thursday?.\nExpected Output: Hi! Sure, Friday works for me. What time are you available?",
  "placeholders.groupName": "Enter group name",
  "placeholders.description": "Enter description",
  "placeholders.noGroup": "No group found",
  "placeholders.search": "Search…",
  "placeholders.knowledgeName": "E.g. Company Policy Document",
  "placeholders.selectChatType": "Select Chat Type...",
  "placeholders.selectSourceType": "Select Source Type...",
  "placeholders.selectTemplate": "Select Template...",
  "placeholders.selectAgent": "Select Agent",
  "placeholders.selectKnowledgeBase": "Select Knowledge Base",
  "placeholders.selectPromptTemplate": "Select prompt template",
  "placeholders.selectPromptTemplates": "Select Prompt Template",
  "placeholders.webUrl": "https://example.com",
  "placeholders.temperature": "0.0",
  "placeholders.maxTokens": "2000",
  "placeholders.selectEmbeddingType": "Select Provider...",
  "placeholders.selectEmbeddingModel": "Select Model",
  "placeholders.selectLlmType": "Select Type",
  "placeholders.selectLlmModel": "Select Model",
  "placeholders.selectApp": "Select App",
  "placeholders.selectGroups": "Select Groups",
  "placeholders.askKnowledgeBase":
    "Ask a question to test the knowledge base...",
  "placeholders.responseAppear": "Response will appear here...",
  "placeholders.selectOrganization": "Select an organization",
  "placeholders.selectRole": "Select a role",
  "placeholders.agentName": "Enter Agent Name",
  "placeholders.organizationName": "Enter Organization Name",
  "placeholders.organizationId": "Enter Organization ID",
  "placeholders.groupId": "Enter Group ID",
  "placeholders.selectKnowledge": "Select Knowledge..",
  "placeholders.typeMessage": "Type your message...",
  "placeholders.typeMessageReady": "Type a message",
  "placeholders.selectAgentToStartChatting": "Select an agent to start chatting",
  "placeholders.chatFieldNotSelected": "{{field}} not selected.",
  "placeholders.chatFieldsNotSelected": "{{fields}} not selected.",
  "placeholders.rolePlaceholder": "ADMIN, USER, MODERATOR",
  "placeholders.taskPlaceholder": "Assistant, Helper, Analyzer",
  "placeholders.documentSummary": "Enter document summary...",
  "placeholders.departmentName": "Enter Department Name",
  "placeholders.userID": "Enter User ID",
  "placeholders.userName": "Enter Full Name",
  "placeholders.documentNumber": "Enter Document Number",
  "placeholders.topP": "0.0",
  "placeholders.topK": "1",
  "placeholders.maxInputTokens": "2000",
  "placeholders.maxOutputTokens": "2000",
  "placeholders.stopSequence": "Enter stop sequence",
  "placeholders.selectCategory": "Select Category..",
  "placeholders.keywords": "e.g. loan, housing, emi",
  "placeholders.queryText": "Enter query text",
  "placeholders.queryName": "Enter query name",
  "placeholder.queryLibrary": "Frequently asked banking-related questions",
  "placeholders.searchFeedback": "Search feedback...",
  "placeholders.selectKnowledgeBases": "Select knowledge bases",
  "placeholders.enterPromptTitle": "Enter Prompt Title",
  "placeholders.firstName": "Enter first name",
  "placeholders.lastName": "Enter last name",
  "placeholders.email": "Enter email address",
  "placeholders.password": "Enter password",
  "placeholders.organization": "Select organization",
  "placeholders.group": "Select group",
  "placeholders.selectOrganizations": "Select organization",
  "placeholders.selectGroup": "Select group",

  "labels.addKnowledge": "Add knowledge",
  "labels.updateKnowledge": "Update Knowledge",
  "labels.updateAgent": "Update Agent",
  "labels.knowledgeName": "Document Name",
  "labels.agents": "Agents",
  "labels.chatType": "Chat Type",
  "labels.sourceType": "Source Type",
  "labels.roles": "Roles",
  "labels.agent": "Agent",
  "labels.lowercaseAgent": "agent",
  "labels.promptTemplate": "Prompt Template",
  "labels.knowledgeBase": "Knowledge Base",
  "labels.knowledgeBaseHint": "If no knowledge base is selected, all available knowledge bases will be used to generate the response.",
  "labels.knowledge": "knowledge",
  "titles.knowledgeSubtitle": "Manage documents and data for your AI.",
  "titles.promptTemplatesSubtitle": "Create and manage prompt templates for consistent AI interactions.",
  "titles.agentsSubtitle": "Build and manage conversational AI assistants.",
  "titles.chatInterfaceSubtitle": "Ask questions and interact with your AI assistants.",
  "titles.performanceDashboardSubtitle": "Monitor and evaluate AI response quality and latency.",
  "titles.userAdoptionInsightsSubtitle": "Track user engagement and adoption trends across the platform.",
  "labels.user.sysAdminProvision": "Manage all users across organizations and groups.",
  "labels.document": "Document",
  "labels.scrapeHyperlinks": "Scrape hyperlinks",
  "labels.documentSummary": "Document Summary",
  "labels.embeddingLLM": "Embedding Model Provider",
  "labels.embeddingModel": "Embedding Model Name",
  "labels.llmType": "LLM Model Type",
  "labels.editFeedback": "Edit feedback",
  "labels.llmModel": "LLM Model Name",
  "labels.temperature": "Temperature",
  "labels.maxTokens": "Max Tokens",
  "labels.tableName": "Name",
  "labels.tableChatType": "Chat Type",
  "labels.tableSource": "Source",
  "labels.tableFilesUrl": "Files / URL",
  "labels.tableActions": "Actions",
  "labels.loading": "Loading...",
  "labels.loadingMessage": "Loading knowledge bases...",
  "labels.loadingAgents": "Loading Agents...",
  "labels.processing": "Processing...",
  "labels.agentName": "Agent Name",
  "labels.groups": "Groups",
  "labels.noEntriesFound": "No entries found.",
  "labels.edit": "Edit",
  "labels.confirm": "Confirm",
  "labels.delete": "Delete",
  "labels.detailsTitle": "Details",
  "labels.fieldKnowledgeName": "Knowledge Name",
  "labels.fieldChatType": "Chat Type",
  "labels.fieldSourceType": "Source Type",
  "labels.fieldRoles": "Roles",
  "labels.fieldEmbeddingLLMType": "Embedding LLM Type",
  "labels.fieldEmbeddingModelName": "Embedding Model Name",
  "labels.fieldLLMModelType": "LLM Model Type",
  "labels.fieldLLMModelName": "LLM Model Name",
  "labels.fieldTemperature": "Temperature",
  "labels.fieldMaxTokens": "Max Tokens",
  "labels.fieldPromptTemplate": "Prompt Template",
  "labels.fieldAgent": "Agent",
  "labels.fieldFilesUrl": "Files / URL",
  "labels.noUsersSelected": "No users found",
  "labels.noUsersMatchSearch": "No users match your search",
  "labels.tooltipAddRootGroup": "Add Root Group",
  "labels.tableHeaderGroupName": "Group Name",
  "labels.description": "Description",
  "labels.tableHeaderUsers": "Users",
  "labels.tableHeaderCreatedAt": "Created At",
  "labels.tableHeaderStatus": "Status",
  "labels.tableHeaderAction": "Action",
  "labels.tooltipAddSubgroup": "Add Subgroup",
  "labels.recordId": "Record ID",
  "labels.timestamp": "Timestamp",
  "labels.input": "Input",
  "labels.output": "Output",
  "labels.performance": "Performance",
  "labels.detailedMetrics": "Detailed Metrics",
  "labels.latency": "Latency",
  "labels.viewFull": "View Full",
  "labels.viewUsers": "View users",
  "labels.collapse": "Collapse",
  "labels.showMore": "Show more",
  "labels.showLess": "Show less",
  "labels.collapseChatSidebar": "Collapse chat sidebar",
  "labels.expandChatSidebar": "Expand chat sidebar",
  "labels.appName": "App Name:",
  "labels.totalQueries": "Total Queries",
  "labels.averageLatency": "Average Latency",
  "labels.totalTokens": "Total Tokens",
  "labels.totalCost": "Total Cost",
  "labels.records": "Records",
  "labels.timeStamp": "TimeStamp",
  "labels.knowledgeBaseDetails": "Knowledge Base Details",
  "labels.inferenceModel": "Inference Model",
  "labels.provider": "Provider",
  "labels.model": "Model",
  "labels.groupName": "Group Name",
  "labels.groupDescription": "Description",
  "labels.tabGroups": "Group Details",
  "labels.tabUsers": "Users",
  "labels.inValidFileType": "Allowed file types- .pdf, .doc, .docx",
  "labels.dropFilesHere": "Drop files here",
  "labels.sortBy": "Sort By: ",
  "labels.name": "Name",
  "labels.newFirst": "Newest First",
  "labels.oldFirst": "Oldest First",
  "labels.departmentName": "Department Name",
  "labels.userID": "User ID",
  "labels.userName": "User Name",
  "labels.documentNumber": "Document Number",
  "labels.documentDate": "Document Date",
  "labels.category": "Category",
  "labels.query": "Query",
  "labels.lowercaseQuery": "query",
  "labels.queries": "Queries",
  "labels.lowercaseQueries": "queries",
  "labels.noQueriesFound": "No queries found. Create your first query to get started!",
  "labels.noQueriesFoundReadOnly": "No queries found.",
  "labels.chat": "Chat",
  "labels.lowercaseChat": "chat",
  "labels.searchQueries": "Search queries...",
  "labels.queryTags": "Query tags",
  "labels.queryName": "Query Name",
  "labels.queryContent": "Query Content",
  "labels.governanceDescription":
    "Monitor response metrics and compliance in real-time",
  "labels.governanceBadge": "Real-time Monitoring",
  "labels.average": "Average",
  "labels.maximum": "Maximum",
  "labels.comingSoon": "Coming Soon",
  "labels.userAdoptionInsightsDescription":
    "Sentiment analysis and behavioral patterns",
  "labels.featureIndevelopment": "Feature in development",
  "labels.piiDescription": "Personally Identifiable Information monitoring",
  "labels.hapDescription": "Hate Abuse and Profanity monitoring",
  "labels.piiMetrics": "PII Metrics",
  "labels.hapMetrics": "HAP Metrics",
  "labels.inputSentimentAnalysis": "Input Sentiment Analysis",
  "labels.inputSentimentAnalysisDescription": "Incoming message analysis",
  "labels.outputSentimentAnalysis": "Output Sentiment Analysis",
  "labels.outputSentimentAnalysisDescription": "Response message analysis",
  "labels.feedbackUserId": "User Id",
  "labels.feedbackUserPF": "User PF",
  "labels.feedbackQuery": "User Query",
  "labels.feedbackResponse": "Response",
  "labels.feedbackSourceRef": "Source Reference",
  "labels.feedbackType": "Feedback Type",
  "labels.feedbackRating": "Rating",
  "labels.feedbackComments": "Comments",
  "labels.veryGood": "Very Good",
  "labels.good": "Good",
  "labels.ok": "OK",
  "labels.partialOk": "Partially OK",
  "labels.notSatisfied": "Not Satisfied",
  "labels.positiveFeedback": "Positive Feedback",
  "labels.negativeFeedback": "Negative Feedback",
  "labels.positive": "Positive",
  "labels.negative": "Negative",
  "labels.accuracyScore": "Accuracy Score",
  "labels.allfeedback": "All Feedback",
  "labels.feedbackSubtitle":
    "Monitor and analyze user feedback across all interactions",
  "labels.noResultsFound": "No Feedback found",
  "labels.liveUsers": "Live Users",
  "labels.liveQueries": "Live Queries",
  "labels.peakUsers": "Peak Users",
  "labels.peakQueries": "Peak Queries",
  "labels.total": "Total",
  "labels.success": "Success",
  "labels.failed": "Failed",
  "labels.liveUsersHourly": "Live Users (Hourly)",
  "labels.liveQueriesHourly": "Live Queries (Hourly)",
  "labels.avgDailyUsers": "Average Daily Users",
  "labels.avgDailyQueries": "Average Daily Queries",
  "labels.zoneWiseActiveUsers": "Zone-wise Active Users",
  "labels.verticalWiseActiveUsers": "Vertical-wise Active Users",
  "labels.avgEngagementTime": "Average Engagement Time (Minutes)",
  "labels.scaleWiseActiveUsers": "Scale-wise Active Users",
  "labels.lastUpdated": "Last updated:",
  "labels.addUser": "Add User",
  "labels.removeUser": "Remove User",
  "labels.editUser": "Edit User",
  "labels.email": "Email",
  "labels.password": "Password",
  "labels.newPassword": "New Password (leave blank to keep current)",
  "labels.role": "Role",
  "labels.organization": "Organization",
  "labels.lowercaseOrganization": "organization",
  "labels.admin": "Admin",
  "labels.user": "User",
  "labels.lowercaseUser": "user",
  "labels.superAdmin": "Super Admin",
  "labels.organization.sysAdminProvision":
    "You can create, update, delete and list organizations, as well as view organization details.",
  "labels.organization.orgAdminProvision":
    "You can only view your organization details.",
  "labels.group.orgAdminProvision":
    "You can create, update, delete, view and list groups and add or remove users from groups.",
  "labels.group.grpAdminProvision":
    "You can view and list your groups, update your own groups  and add or remove users from them.",
  "labels.group.userProvision": "You can only view your own groups.",
  "labels.organizationName": "Organization Name",
  "labels.pointers": "Pointers",
  "labels.queryDescription": "Query Description",
  "labels.noPromptGuidanceTitle": "No Prompt guidance Yet",
  "labels.prompt": "prompt",
  "labels.noPromptGuidanceSubtitle":
    "Create your first prompt guidance to help users write better AI prompts.",
  "labels.promptGuidance.create": "Create prompt guidance",
  "labels.promptGuidance.update": "Update prompt guidance",
  "labels.noPromptGuidanceRulesTitle": "No Prompt Guidance rules yet",
  "labels.noPromptGuidanceRulessubtitle":
    "Prompt Guidance helps users understand how to write effective AI prompts. Currently, there are no rules defined for your account. Only system administrators can create, edit, or delete prompt guidance rules.",
  "labels.promptGuidance.heading": "Prompt Guidance",
  "labels.promptGuidance.subheading":
    "Learn how to write effective prompts for better AI response",
  "labels.firstName": "First Name",
  "labels.lastName": "Last Name",
  "labels.group.title": "Create your first group",
  "labels.group": "group",
  "labels.group.subtitle":
    "Groups help you organize users and resources within an organization.\n Create your first group to start managing access and permissions.",
  "labels.noGroups": "No groups yet",
  "labels.noGroups.descrition":
    "You're not part of any group. Groups help you collaborate with others and share access to AI agents, queries, and configurations.",
  "labels.userProfile": "User Profile",
  "labels.userProfile.manage": "Manage your profile details",
  "labels.settings.subtitle": "Manage your account preferences and appearance",
  "labels.settings.appearance": "Customize how the application looks",
  "labels.theme": "Theme",
  "labels.language": "Language",
  "labels.citations": "Citations",
  "labels.llmReasoning": "LLM Reasoning",
  "labels.explainability.notFound": "No interactions match your search.",
  "labels.permissions.SystemAdmin.organization.create": "Create organizations",
  "labels.permissions.SystemAdmin.organization.update": "Update organizations",
  "labels.permissions.SystemAdmin.organization.delete": "Delete organizations",
  "labels.permissions.SystemAdmin.organization.list": "View all organizations",
  "labels.permissions.SystemAdmin.organization.view":
    "View organization details",
  "labels.permissions.SystemAdmin.user.createBootstrap":
    "Create bootstrap users",
  "labels.permissions.OrgAdmin.organization.viewOwn":
    "View your organization's details",
  "labels.permissions.OrgAdmin.user.create": "Create users",
  "labels.permissions.OrgAdmin.user.update": "Update users",
  "labels.permissions.OrgAdmin.user.delete": "Delete users",
  "labels.permissions.OrgAdmin.user.list": "View all users",
  "labels.permissions.OrgAdmin.user.view": "View user details",
  "labels.permissions.OrgAdmin.group.create": "Create groups",
  "labels.permissions.OrgAdmin.group.update": "Update groups",
  "labels.permissions.OrgAdmin.group.delete": "Delete groups",
  "labels.permissions.OrgAdmin.group.view": "View group details",
  "labels.permissions.OrgAdmin.group.list": "View all groups",
  "labels.permissions.OrgAdmin.group.addUser": "Add user to group",
  "labels.permissions.OrgAdmin.group.removeUser": "Remove user from group",
  "labels.permissions.GroupAdmin.user.updateOwnGroup":
    "Update users in your group",
  "labels.permissions.GroupAdmin.user.viewOwnGroup": "View users in your group",
  "labels.permissions.GroupAdmin.user.listOwnGroup":
    "View all users in your group",
  "labels.permissions.GroupAdmin.group.update": "Update your group",
  "labels.permissions.GroupAdmin.group.view": "View your group",
  "labels.permissions.GroupAdmin.group.list": "View your groups",
  "labels.permissions.GroupAdmin.group.addUser": "Add users to a group",
  "labels.permissions.GroupAdmin.group.removeUser": "Remove users from a group",
  "labels.permissions.User.group.viewOwn": "View your group",
  "labels.access": "Your Access",
  "labels.accessSentence":
    "As {{article}} {{role}}, you have access to the following permissions",
  "labels.startDate": "Start Date",
  "labels.endDate": "End Date",
  "labels.noRAIMetricsTitle": "Oops! No data found for the selected date range",
  "labels.noRAIMetricsSubtitle":
    'It seems there are no RAI metrics available for this period. Try adjusting the start and end dates above, then click "Search" again to reload the data.',
  "labels.workspace": "Workspace",
  "labels.newChat": "New chat",
  "labels.chatHistory": "Chat History",
  "labels.retry": "Retry",
  "labels.recent": "Recent",
  "labels.settingsAndHelp": "Settings and help",
  "labels.user.grpAdminProvision":
    "You can update, view and list your own groups.",
  "labels.user.orgAdminProvision":
    "You can update, view and list your own groups.",
  "labels.toggleTheme": "Toggle theme",
  "labels.selectLanguage": "Select language",
  "labels.editTemplate": "Update Template",
  "labels.from": "From",
  "labels.to": "To",

  "alerts.unableToLoad": "Unable to load",
  "alerts.noHourlyUserData": "No hourly user data available",
  "alerts.noHourlyQueryData": "No hourly query data available",
  "alerts.noDailyUserData": "No daily user data available",
  "alerts.noDailyQueryData": "No daily query data available",
  "alerts.noZoneData": "No zone data available",
  "alerts.noVerticalData": "No vertical data available",
  "alerts.noEngagementData": "No engagement data available",
  "alerts.noScaleData": "No scale data available",
  "alerts.noInputSentimentData": "No input sentiment data available",
  "alerts.noOutputSentimentData": "No output sentiment data available",
  "alerts.noHapData": "HAP detection data not available",
  "alerts.noPiiData": "PII detection data not available",
  "alerts.noBiasData": "Bias detection data not available",
  "alerts.noContextRelevancyData": "Context relevancy data not available",
  "alerts.noAnswerRelevancyData": "Answer relevancy data not available",
  "alerts.noRetrievalPrecisionData": "Retrieval precision data not available",
  "alerts.noHallucinationData": "Hallucination data not available",

  "emptyStates.noLatencyData": "No latency data available for the selected date range",
  "emptyStates.noThroughputData": "No throughput data available for the selected date range",
  "emptyStates.noContextDriftData": "No context drift data available",
  "emptyStates.noResponseDriftData": "No response drift data available",
  "emptyStates.noAccuracyData": "No accuracy score data available",
  "emptyStates.noRetrievalPrecisionData": "No retrieval precision score data available",
  "emptyStates.dataNotFound": "Data not found",

  "buttons.saveChangesButton": "Save Changes",
  "buttons.createTemplateButton": "Create Template",
  "buttons.updateVersionButton": "Update Version",
  "buttons.createAgentButton": "Create Agent",
  "buttons.cancelButton": "Cancel",
  "buttons.addTemplateButton": "Add Template",
  "buttons.backButton": "← Back",
  "buttons.createVersionButton": "Create Version",
  "buttons.addGroupButton": "Add Group",
  "buttons.addSubgroupButton": "Add Subgroup",
  "buttons.addUser": "Add User",
  "buttons.remove": "Remove",
  "buttons.addUserButton": "Add",
  "buttons.createSubgroupButton": "Create Subgroup",
  "buttons.createGroupButton": "Create Group",
  "buttons.editGroupButton": "Edit Group",
  "buttons.editAgentButton": "Edit Agent",
  "buttons.editTemplateButton": "Edit Template",
  "buttons.editVersionButton": "Edit Version",
  "buttons.addKnowledge": "Add Knowledge",
  "buttons.addAgent": "Add Agent",
  "buttons.basicSettingsTab": "Basic Settings",
  "buttons.advancedSettingsTab": "Advanced Settings",
  "buttons.selectFiles": "Select Files",
  "buttons.generateSummary": "Generate summary using AI",
  "buttons.generatingSummary": "Generating...",
  "buttons.createKnowledge": "Create Knowledge",
  "buttons.updateKnowledge": "Update Knowledge",
  "buttons.creatingInProgress": "Creating...",
  "buttons.updatingInProgress": "Updating...",
  "buttons.next": "Next",
  "buttons.back": "Back",
  "buttons.webUrl": "Web URL",
  "buttons.AddGroupButton": "Add",
  "buttons.signingInButton": "Signing In...",
  "buttons.signInButton": "Sign In",
  "buttons.uploadFiles": "Click to select files or drag and drop",
  "buttons.addQuery": "Add Query",
  "buttons.copyQuery": "Copy Query",
  "buttons.useQuery": "Use Query",
  "buttons.createQuery": "Create Query",
  "buttons.updateQuery": "Update Query",
  "buttons.refresh": "Refresh",
  "buttons.exportReport": "Export Report",
  "buttons.okay": "Okay",
  "buttons.close": "Close",
  "buttons.create": "Create",
  "buttons.createUser": "Create User",
  "buttons.updateUser": "Update User",
  "buttons.search": "Search",
  "buttons.viewMore": "View more",
  "buttons.viewLess": "View less",

  "actions.view": "View",
  "actions.edit": "Edit",
  "actions.delete": "Delete",
  "actions.close": "Close",
  "actions.confirm": "Confirm",
  "actions.cancel": "Cancel",
  "actions.create": "Create",
  "actions.selectAll": "Select all",
  "actions.deleteVersion": "Delete Version",
  "actions.deleteTemplate": "Delete Template",


  "formValidationErrors.templateName": "Template name is required.",
  "formValidationErrors.role": "Role is required.",
  "formValidationErrors.task": "Task is required.",
  "labels.createOrganization": "Create Organization",
  "labels.updateOrganization": "Update Organization",
  "labels.promptTitle": "Prompt title",
  "labels.organizationId": "Organization ID",
  "labels.groupId": "Group ID",

  "sideBarLabels.playground": "Playground",
  "sideBarLabels.chatInterface": "Chat Interface",
  "sideBarLabels.userManagement": "User Management",
  "sideBarLabels.groups": "Groups",
  "sideBarLabels.organizations": "Organizations",
  "sideBarLabels.aiMetrics": "RAI Metrics",
  "sideBarLabels.knowledgeStore": "Knowledge Store",
  "sideBarLabels.prompts": "Prompts",
  "sideBarLabels.settings": "Settings",
  "sideBarLabels.logout": "Log out",
  "sideBarLabels.user": "User",
  "sideBarLabels.aiSettings": "AI Settings",
  "sideBarLabels.appearance": "Appearance",
  "sideBarLabels.admin": "Admin",
  "sideBarLabels.queryLibrary": "Query Library",
  "sideBarLabels.governanceDashboard": "Governance Dashboard",
  "sideBarLabels.performanceDashboard": "Performance Dashboard",
  "sideBarLabels.agents": "Agents",
  "sideBarLabels.userAdoptionInsights": "User Adoption Insights",
  "sideBarLabels.feedbackReport": "Feedback Report",
  "sideBarLabels.promptGuidance": "Prompt Guidance",
  "sideBarLabels.explainability": "Explainability",

  "appLabels.appName": "GenAI Studio",
  "appLabels.appDescription":
    "Build, test, and monitor GenAI-powered applications.",

  "labels.enterCredentials": "Enter your credentials to access your account",
  "titles.agents": "Agents",
  "titles.name": "Name",
  "titles.id": "ID",
  "titles.version": "Version",
  "titles.email": "Email",
  "titles.organization": "Organization",
  "titles.groups": "Groups",
  "titles.roles": "Role",
  "titles.task": "Task",
  "titles.requirements": "Requirements",
  "titles.details": "Additional Details",
  "titles.restrictions": "Restrictions",
  "titles.format": "Output Format",
  "titles.examples": "Examples & Samples",
  "titles.updated": "Updated",
  "titles.actions": "Actions",
  "titles.knowledgeStore": "Knowledge Store",
  "titles.knowledgeBase": "Knowledge Bases",
  "titles.chatConfiguration": "AI Agent Setup",
  "titles.promptTemplates": "Prompt Templates",
  "titles.summary": "Summary",
  "titles.groupManagement": "Group Management",
  "titles.recordDetails": "Record Details",
  "titles.aiMetrics": "RAI Metrics",
  "titles.hapDetection": "HAP Detection",
  "titles.hapSubtitle": "Hate, Abuse, Profanity",
  "titles.piiDetection": "PII Detection",
  "titles.piiSubtitle": "Personal Information",
  "titles.latency": "Latency",
  "titles.latencySubtitle": "Average Chat Latency (ms)",
  "titles.throughput": "Throughput",
  "titles.throughputSubtitle": "Chat Requests Per Second",
  "titles.contextDrift": "Context Drift",
  "titles.responseDrift": "Response Drift",
  "titles.accuracy": "Accuracy",
  "titles.contextDriftSubtitle": "Average Context Drift Score (0-1)",
  "titles.responseDriftSubtitle": "Average Response Drift Score (0-1)",
  "titles.accuracySubtitle": "Average Accuracy Score (0-1)",
  "titles.retrievalPrecisionSubtitle": "Average Retrieval Precision Score (0-1)",
  "titles.input": "Input",
  "titles.output": "Output",
  "titles.tokenMetrics": "Token Metrics",
  "titles.biasDetection": "Bias Detection",
  "titles.relevancyScore": "Relevancy Score",
  "titles.precisionScore": "Precision Score",
  "titles.comingSoon": "Coming soon",
  "titles.feedbackResults": "Feedback Results",
  "titles.conversationAnalysis": "Conversation Analysis",
  "titles.temperature": "Temperature",
  "titles.topP": "Top-P",
  "titles.topK": "Top-K",
  "titles.maxInputTokens": "Max Input Tokens",
  "titles.maxOutputTokens": "Max Output Tokens",
  "titles.stopSequence": "Stop Sequence",
  "titles.guidelines": "Guidelines",
  "titles.technicalParameters": "Technical Parameters",
  "titles.queryLibrary": "Query Library",
  "titles.governanceDashboard": "Governance Dashboard",
  "titles.performanceDashboard": "Performance Dashboard",
  "titles.userAdoptionInsights": "User Adoption Insights",
  "titles.liveAnalysis": "Live Analysis",
  "titles.feedback": "Feedback",
  "titles.feedbackDetails": "Feedback Details",
  "titles.feedbackReport": "Feedback Report",
  "titles.copyToClipboard": "Copy to clipboard",
  "titles.copied": "Copied!",
  "titles.select.agent": "Select agent",
  "titles.selectModel": "Select Model",
  "titles.contextRelevancy": "Context Relevancy",
  "titles.answerRelevancy": "Answer Relevancy",
  "titles.retrievalPrecision": "Retrieval Precision",
  "titles.sentiment": "Sentiment",
  "titles.hallucination": "Hallucination",
  "titles.manageOrganization": "Manage Organization",
  "titles.sysAdminProvisioning": "System Administrator Provisioning",
  "titles.updateGroup": "Update Group",
  "descriptions.sysAdminProvisioning":
    "As a System Administrator, you can create, update, view, and delete organizations, managing the full organization lifecycle within the system.",
  "titles.createUser": "Create User",
  "titles.orgAdminProvisioning": "Organization Administrator Provisioning",
  "titles.updateUser": "Update User",
  "titles.viewUser": "User Details",
  "descriptions.orgAdminProvisioning":
    "As a System Administrator, you can create a single Organization Administrator for each registered organization. The Organization Administrator will be responsible for managing users, groups, and access within their organization.",
  "errors.validation.notBlank.fieldName": "{{fieldName}} is required",
  "errors.groupNameRequired": "Group name is required",
  "errors.groupDescriptionRequired": "Group description is required",
  "sessionExpiryModal.title": "Session Expiring Soon",
  "sessionExpiryModal.message":
    "Your session is about to expire. Extend your session to continue working without interruption.",
  "sessionExpiryModal.extendButton": "Extend Session",
  "sessionExpiryModal.extendingButton": "Extending Session",
  "sessionExpiryModal.remaining": "remaining ",

  "validation.firstNameRequired": "First name is required",
  "validation.lastNameRequired": "Last name is required",
  "validation.emailRequired": "Email is required",
  "validation.emailInvalid": "Invalid email address",
  "validation.passwordRequired": "Password is required",
  "validation.passwordInvalid":
    "Password must be at least 8 characters long and include uppercase, lowercase, number, and special character",
  "validation.roleRequired": "Role is required",
  "validation.organizationRequired": "Organization is required",
  "validation.groupRequired": "Group is required",
  "validation.knowledgeNameRequired": "Document name is required",
  "validation.departmentNameRequired": "Department name is required",
  "validation.documentNumberRequired": "Document number is required",
  "validation.documentDateRequired": "Document date is required",
  "validation.agentRequired": "Agent is required",
  "validation.embeddingProviderRequired": "Embedding provider is required",
  "validation.embeddingModelRequired": "Embedding model is required",
  "labels.activity": "Activity",
  "labels.sources": "Sources",
  "labels.activity.notFound": "No activity recorded for this response.",
  "labels.sources.notFound": "No sources referenced for this response.",
  "labels.aiGeneratedContent": "AI-generated content · may not always be accurate.",
  "labels.explainability": "Explainability",
  "labels.followupQuestions": "Follow-up Questions:",
  "toastMessages.failedToGetMessage": "Failed to get message",
  "toastMessages.serverError": "Something went wrong",
  "toastMessageDescriptions.serverError": "We couldn't process your request. Please try again later.",
  "toastMessageDescriptions.chatErrorUser": "Something went wrong while fetching your answer. Try rephrasing your question or come back in a moment — it may just be a temporary issue on our end.",
  "toastMessageDescriptions.chatErrorAdmin": "Something went wrong while fetching your answer. Try rephrasing your question or reviewing your prompt template for inconsistencies. If the issue persists, come back in a moment — it may just be a temporary disruption.",
  "labels.userQueryPiiMasking": "Securing your data...",
  "labels.semanticCacheSearch": "Checking past insights...",
  "labels.inputGuardrailsValidation": "Reviewing input for safety...",
  "labels.documentRetrieval": "Searching knowledge base...",
  "labels.chainStreamingResponse": "Crafting your answer...",
  "labels.responsePiiMasking": "Securing response data...",
  "labels.outputGuardrailsValidation": "Reviewing response quality....",
  "labels.generateSources": "Gathering references...",
  "labels.generateFollowUpQuestions": "Thinking of what’s next...",
  "labels.promptTemplateMessage": "Structuring the query...",
  "labels.completed": "Completed",
  "labels.raiMetricsSubtitle": "Responsible AI performance dashboard",
  "labels.chat.configure": "Configure chat to start conversation",
  "titles.chat.heading": "🤖 Hello,",
  "titles.chat.subHeading": "How can I help you?",
  "titles.chat.description":
    "Configure your chat by selecting an agent, model, knowledge base, and prompt template from the right panel.",
  "chat.disclaimer":
    "This content is AI-generated and can sometimes be incorrect.",
};
